import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { customFilterOperations } from '../../redux/customFilter';
import { userOperations } from '../../redux/user';
import { incidentsOperations } from '../../redux/incidentList';
import ReactScrollableList from 'react-scrollable-list';
import RaisedButton from 'material-ui/RaisedButton';
import Button from '@material-ui/core/Button';
import CustomFiltersDialog from './CustomFiltersDialog';
import CircularProgress from 'material-ui/CircularProgress';
import TrashIcon from 'material-ui/svg-icons/action/delete';
import CallMadeIcon from '@material-ui/icons/CallMade';
import EditIcon from '@material-ui/icons/Edit';
import { buildFilter } from './utils/sqlUtils';
import { setCustomFilterDefinitionExpression } from '../esri/mapHub';
import { v4 as uuidv4 } from 'uuid';

class CustomFiltersList extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
        showingCustomFilterDialog: false,
        filterForEdit: null,
        filterIsLoading: false,
        filterForEditId: null
    };
  }

  launchCustomFilters = (event) =>
  {
    event.preventDefault();

    this.setState({
      showingCustomFilterDialog: true
    });
  };

  customFiltersClose = () =>
  {
    this.setState({
      showingCustomFilterDialog: false,
      filterForEdit: null
    });
  }

    editFilter = (item) =>
    {
      this.setState({
        showingCustomFilterDialog: true,
        filterForEdit: item,
        filterForEditId: item.CustomFilterID
      });
    }

    deleteFilter = (item) =>
    {
      window.api.deleteCustomFilter(item.CustomFilterID).then( response => {   
        this.props.setCustomFilters(response);
      });
    }

  duplicateFilter = (item) =>
    {
      const clonedItem = JSON.parse(JSON.stringify(item));
      clonedItem.filterGuid = uuidv4();
      clonedItem.Title = "Copy of " + clonedItem.Title;

      this.setState({
        showingCustomFilterDialog: true,
        filterForEdit: clonedItem,
        filterForEditId: null
      });
    }

  filterListItemClicked = (item) =>
  {
    debugger;
    const filterContent = JSON.parse(item.FilterContent);
    let activeDefinitionExpression = buildFilter(filterContent);
    this.props.setActiveCustomFilter(filterContent, activeDefinitionExpression);
    this.setState({
      filterIsLoading: true
    });

    setCustomFilterDefinitionExpression(activeDefinitionExpression).then( response => {
      this.props.setQueriedIncidentsTotal(response.total);
      this.props.setDisplayedIncidentsCount(response.features.length);
      this.props.setIncidents(response.features);
      this.props.setVisibleIncidents(response.features);
      this.setState({
        filterIsLoading: false
      });
    });
  }

  render() {

    let sortedCustomFilters;
    let filterHeaderContent;

    const currentDisplayed = this.props.incidentList.displayedIncidentsCount;
    const queryTotal = this.props.incidentList.queriedIncidentsTotal;
    const labelText = (queryTotal === currentDisplayed) ? 'Showing All ' + currentDisplayed + ' Incidents' : ' Showing ' + currentDisplayed + ' of ' + queryTotal + ' Incidents';
    
    if(this.state.filterIsLoading)
    {
     filterHeaderContent =
     (
       <div style={{textAlign: "center", marginTop: "22px"}}><CircularProgress size={24} thickness={2} /></div>
     )
   }
   else
   {
     filterHeaderContent =
     (
         <div style={{textAlign: "center", marginTop: "22px"}}>{labelText}</div>
     )
   }

    sortedCustomFilters = this.props.user.customFilters.sort((a, b) => {
        return (a.Title < b.Title) ? -1 : 1;
      }).map((item, i) => {

        const filterContent = JSON.parse(item.FilterContent);
        const showHighlighted = (this.props.user.activeCustomFilterState && (filterContent.filterGuid === this.props.user.activeCustomFilterState.filterGuid));

       return {
           id: i,
           content: (
             <Fragment>
             <Button
               color="primary"
               variant={(showHighlighted) ? "contained" : "text"}
               onClick={e => { this.filterListItemClicked(item) } }>{item.Title}</Button>

               <CallMadeIcon
                 className="filter-item-header-clear"
                 onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.duplicateFilter(item)
             }}
               style={{width: "20px", height: "20px", float: "right", paddingTop:"8px"}} />
               <EditIcon
                 color="primary"
                 onClick={(e) => {
                   e.preventDefault();
                   e.stopPropagation();
                   this.editFilter(item)
                }}
                  style={{width: "20px", height: "20px", float: "right", paddingRight: "15px", paddingLeft: "15px", paddingTop:"8px"} } />

                  <TrashIcon
                  className="filter-item-header-clear"
                  onClick={(e) => {
                   e.preventDefault();
                   e.stopPropagation();
                   this.deleteFilter(item);
                }}
                  style={{width: "20px", height: "20px", float: "right", paddingTop:"8px"}} />
               </Fragment>
           )
         }
     });

    return (
      <Fragment>
      {filterHeaderContent}
      <RaisedButton
        color="primary"
        style={{marginTop: "10px", marginLeft:"15px"}}
        onClick={this.launchCustomFilters}
        label="Add Custom Filter"/>
        <ReactScrollableList
         listItems={sortedCustomFilters}
         heightOfItem={105} />

         <CustomFiltersDialog
           open={this.state.showingCustomFilterDialog}
           onClose={this.customFiltersClose}
           filterForEdit={this.state.filterForEdit}
           filterForEditId={(this.state.filterForEdit) ? this.state.filterForEditId : null}
           filterTitle={(this.state.filterForEdit) ? this.state.filterForEdit.Title : ''}
           />
       </Fragment>

    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...userOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomFiltersList)
